export enum PersonalizedAreaActions {
  DETECT_FEATURES = "DETECT_FEATURES",
  DETECT_FEATURES_START = "DETECT_FEATURES_START",
  DETECT_FEATURES_SUCCESS = "DETECT_FEATURES_SUCCESS",
  DETECT_FEATURES_FAIL = "DETECT_FEATURES_FAIL"
}
